<template>
  <v-row dense>
    <v-progress-linear v-show="loading"></v-progress-linear>
    <v-col cols="12" v-for="(item, i) in items" :key="i">
      <v-card
        tile
        elevation="0"
        class="mb-2 px-4 py-2"
        @click="$router.push({ name: 'job-details', params: { id: item.id } })"
      >
        <v-row class="ma-0 py-4 card-row">
          <span class="text-section-title">Task</span>
          <p class="mx-2">{{ item.name }}</p>
        </v-row>
        <v-divider></v-divider>
        <v-row class="ma-0 py-4 card-row">
          <span class="text-section-title">Project</span>
          <p class="mx-2">{{ getItemProjectName(item) }}</p>
        </v-row>
        <v-divider></v-divider>
        <v-row
          class="ma-0 py-4 card-row"
          justify="space-between"
          align="center"
        >
          <v-row class="ma-0 pa-0">
            <span class="text-section-title">Due</span>
            <p class="mx-2">{{ formattedDate(item.dueDate) }}</p>
          </v-row>

          <status-display :status="item.status"></status-display>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { db } from '@/firebaseConfig'
import { formattedDate } from '@/common'
import StatusDisplay from '@/components/StatusDisplay.vue'
export default {
  props: {
    search: {
      type: Array,
      validator: (prop) => prop.every((e) => e.length === 3),
    },
  },
  components: {
    StatusDisplay,
  },
  data: () => ({
    items: [],
    loading: true,
    formattedDate,
  }),
  mounted() {
    this.loadData()
  },
  computed: {
    ...mapGetters(['companyId']),
    tasksRef() {
      return db.collection(`companies/${this.companyId}/jobs`)
    },
  },
  methods: {
    ...mapActions(['showError']),
    getItemProjectName(item) {
      return item.project?.name ?? '-'
    },
    async loadData() {
      try {
        this.loading = true

        let dbRef = this.tasksRef
        dbRef.orderBy('dueData')
        this.search.forEach((e) => {
          dbRef = dbRef.where(e[0], e[1], e[2])
        })

        const snapshot = await dbRef.get()

        this.items = snapshot.docs.map((doc) => {
          const item = doc.data()
          Object.defineProperty(item, 'id', {
            value: doc.id,
          })
          return item
        })
      } catch (error) {
        this.showError(
          '<b>Failed to load tasks.</b>\n' + error.message ?? 'Try again later'
        )
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.card-row
  max-height: 58px

p
  margin: 0
</style>
